// extracted by mini-css-extract-plugin
export default {"open-app":"_kon05m","openApp":"_kon05m","loader":"_e94ein","text":"_rfuy6x","empty-pic":"_onz6e6","emptyPic":"_onz6e6"};